import React from "react"

import gradient from "../utils/gradient"

import "./CountryCardOverall.scss"
import DataLoader, { years } from "../DataLoader"
import CountryFactorFillGraph from "../CountryFactorFillGraph/"
//import { factorImages } from "../images/factor_icons/factorImages"
//import HistoricalBubbleGraph from "../HistoricalBubbleGraph/"
import arrowDown from "../images/arrow-down.svg"
import arrowUp from "../images/arrow-up.svg"
import arrowDownDark from "../images/arrow-down-dark.svg"
import arrowUpDark from "../images/arrow-up-dark.svg"
import { animated, useSpring } from "react-spring"

export default function CountryCardOverall(props) {
  const {
    selectedCountry,
    selectedYear,
    selectedFactor,
    factorIndex,
    factorSelected,
    countryData,
    scoreKey,
  } = props
  const yearIndex = years.indexOf(selectedYear)
  const title = factorSelected ? (
    <span>
      {factorIndex + 1} | {selectedFactor} for {selectedCountry}, {selectedYear}
    </span>
  ) : (
    `${selectedCountry} Overall Score, ${selectedYear}`
  )

  const overallTitle = `${
    factorSelected ? `Factor ${factorIndex + 1}` : "Overall"
  } Score`

  const score = countryData[scoreKey]
  const overallColor = gradient(score)

  const globalRank = countryData[`${scoreKey}_Rank_Global`]
  const regionRank = countryData[`${scoreKey}_Rank_Region`]
  const incomeRank = countryData[`${scoreKey}_Rank_Income Group`]

  const globalDemoninator = countryData.Count_Global
  const regionDemoninator = countryData.Count_Region
  const incomeDenominator = countryData["Count_Income Group"]
  let rankChange = 0
  let scoreChange = 0
  let overallCOTIcon = null
  let globalRankCOTIcon = null
  // let regionalRankCOTIcon = null
  // let incomeRankCOTIcon = null
  let hasPreviousYearData = false

  let rankChangeIcon = null
  let scoreChangeIcon = null
  if (yearIndex !== 0) {
    const previousYear = years[yearIndex - 1]
    const previousYearData = DataLoader.dataByYear[previousYear].countries.find(
      (country) => country.Country === selectedCountry,
    )
    if (previousYearData) {
      hasPreviousYearData = true

      const previousYearScore = previousYearData[scoreKey]
      scoreChange = score - previousYearScore

      if (scoreChange > 0) {
        overallCOTIcon = (
          <img
            src={arrowUp}
            className="updownArrow"
            width={12}
            height={13}
            alt=""
          />
        )
        scoreChangeIcon = (
          <img
            src={arrowUpDark}
            className="updownArrowSmall"
            width={12}
            height={13}
            alt=""
          />
        )
      } else if (scoreChange < 0) {
        overallCOTIcon = (
          <img
            src={arrowDown}
            className="updownArrow"
            width={12}
            height={13}
            alt=""
          />
        )
        scoreChangeIcon = (
          <img
            src={arrowDownDark}
            className="updownArrowSmall"
            width={12}
            height={13}
            alt=""
          />
        )
      }

      const globalRankIndexedByLastYearsCountriesOnly =
        countryData[`${scoreKey}_Rank_Global_lastYear`]
      // const regionRankIndexedByLastYearsCountriesOnly =
      //   countryData[`${scoreKey}_Rank_Region_lastYear`]
      // const incomeRankIndexedByLastYearsCountriesOnly =
      //   countryData[`${scoreKey}_Rank_Income Group_lastYear`]

      const previousYearGlobalRank = previousYearData[`${scoreKey}_Rank_Global`]
      // const previousYearRegionRank = previousYearData[`${scoreKey}_Rank_Region`]
      // const previousYearIncomeRank =
      //   previousYearData[`${scoreKey}_Rank_Income Group`]

      rankChange =
        previousYearGlobalRank - globalRankIndexedByLastYearsCountriesOnly
      rankChangeIcon =
        rankChange === 0 ? null : (
          <img
            src={rankChange < 0 ? arrowDownDark : arrowUpDark}
            className="updownArrowSmall"
            width={12}
            height={13}
            alt=""
          />
        )
      if (previousYearGlobalRank < globalRankIndexedByLastYearsCountriesOnly) {
        globalRankCOTIcon = (
          <img
            src={arrowDownDark}
            className="updownArrowSmall"
            width={12}
            height={13}
            alt=""
          />
        )
      } else if (
        previousYearGlobalRank > globalRankIndexedByLastYearsCountriesOnly
      ) {
        globalRankCOTIcon = (
          <img
            src={arrowUpDark}
            className="updownArrowSmall"
            width={12}
            height={13}
            alt=""
          />
        )
      }
      // if (previousYearRegionRank < regionRankIndexedByLastYearsCountriesOnly) {
      //   regionalRankCOTIcon = (
      //     <img src={arrowDownDark} className="updownArrowSmall" alt="" />
      //   )
      // } else if (
      //   previousYearRegionRank > regionRankIndexedByLastYearsCountriesOnly
      // ) {
      //   regionalRankCOTIcon = (
      //     <img src={arrowUpDark} className="updownArrowSmall" alt="" />
      //   )
      // }
      // if (previousYearIncomeRank < incomeRankIndexedByLastYearsCountriesOnly) {
      //   incomeRankCOTIcon = (
      //     <img src={arrowDownDark} className="updownArrowSmall" alt="" />
      //   )
      // } else if (
      //   previousYearIncomeRank > incomeRankIndexedByLastYearsCountriesOnly
      // ) {
      //   incomeRankCOTIcon = (
      //     <img src={arrowUpDark} className="updownArrowSmall" alt="" />
      //   )
      // }
    }
  }
  const [values, setValues] = useSpring(() => ({
    score: 0,
    globalRank: 0,
    globalDemoninator: 0,
    regionRank: 0,
    regionDemoninator: 0,
    incomeRank: 0,
    incomeDenominator: 0,
    rankChange: 0,
    scoreChange: 0,
  }))

  setValues({
    score,
    globalRank,
    globalDemoninator,
    regionRank,
    regionDemoninator,
    incomeRank,
    incomeDenominator,
    rankChange,
    scoreChange,
  })

  return (
    <div className="countryCard">
      <div className="title fontTitle">
        <a
          name="overall"
          className="cardAnchor"
          href="#overall"
          aria-hidden="true"
          tabIndex={-1}
        />
        {title}
      </div>

      <div className="quickStats">
        <div>
          <div className="statHeader fontCaps">{overallTitle}</div>
          <div className="value" style={{ backgroundColor: overallColor }}>
            <animated.span>
              {values.score.interpolate((s) => s.toFixed(2))}
            </animated.span>
            {overallCOTIcon}
          </div>
        </div>
        <div>
          <div className="statHeader fontCaps">Global Rank</div>
          <div className="value">
            <animated.span>
              {values.globalRank.interpolate(Math.round)}
            </animated.span>
            /
            <animated.span>
              {values.globalDemoninator.interpolate(Math.round)}
            </animated.span>{" "}
            {globalRankCOTIcon}
          </div>
        </div>
        <div>
          <div className="statHeader fontCaps">Regional Rank</div>
          <div className="value">
            <animated.span>
              {values.regionRank.interpolate(Math.round)}
            </animated.span>
            /
            <animated.span>
              {values.regionDemoninator.interpolate(Math.round)}
            </animated.span>{" "}
            {
              //regionalRankCOTIcon
            }
          </div>
        </div>
        <div>
          <div className="statHeader fontCaps">Income Rank</div>
          <div className="value">
            <animated.span>
              {values.incomeRank.interpolate(Math.round)}
            </animated.span>{" "}
            /
            <animated.span>
              {values.incomeDenominator.interpolate(Math.round)}
            </animated.span>{" "}
            {
              //incomeRankCOTIcon
            }
          </div>
        </div>
        <div>
          <div className="statHeader fontCaps">Rank Change</div>
          <div className="value">
            <animated.span>
              {values.rankChange.interpolate((c) =>
                hasPreviousYearData
                  ? c === 0
                    ? "0"
                    : c > 0
                    ? `+${Math.round(c)}`
                    : Math.round(c)
                  : "-",
              )}
            </animated.span>{" "}
            {rankChangeIcon}
          </div>
        </div>
        <div>
          <div className="statHeader fontCaps">Score Change</div>
          <div className="value">
            <animated.span>
              {values.scoreChange.interpolate((c) => {
                const valueSignless = Math.abs(c).toFixed(2)
                const valueWithSign = c > 0 ? `+${c.toFixed(2)}` : c.toFixed(2)
                const value =
                  valueSignless === "0.00" ? valueSignless : valueWithSign
                return hasPreviousYearData ? (c === 0 ? "0.00" : value) : "-"
              })}
            </animated.span>{" "}
            {scoreChangeIcon}
          </div>
        </div>
        <div>
          <div className="arrowText">
            <p>Arrows signify year-to-year change.</p>
            <p>
              Scores and changes in score are rounded to two decimal places.
            </p>
          </div>
        </div>
      </div>
      <div className="countryFactorGraph">
        <CountryFactorFillGraph
          scoreKey={scoreKey}
          {...props}
          printStyle="fullWidth"
        />
      </div>
    </div>
  )
}
